<template>
  <div>
    <vs-prompt
      id="document-move-dialog"
      @accept="moveDocument"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showDialog"
      :title="methodName"
      :accept-text="methodName"
      :cancel-text="cancelText"
      :is-valid="validatePath"
    >
      <select-path-template
        :targetDocments="moveTargetDocments"
        :methodName="methodName"
        :validate="validateExists"
      >
      </select-path-template>

      <VuePerfectScrollbar 
        class="scroll-area px-4 mt-2" 
        :settings="scrollbarSettings"
      >
        <span
          class="text-danger break-all"
          style="font-size: 11px;"
          v-show="validatePath && duplicatedItems.length > 0"
        >
          <p v-for="(item, index) in duplicatedItems" :key="index">
            {{ item.type }}「{{ item.path }}」
          </p>
          <p>は既に存在します。</p>
          <p>{{ methodName }}すると元の書類は上書きされます。</p>
        </span>
      </VuePerfectScrollbar>
    </vs-prompt>
  </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SelectPathTemplate from "./components/DocumentSelectPathTemplate";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { SelectPathTemplate, VuePerfectScrollbar },
  props: {
    moveTargetDocments: {
      type: Array,
      required: true,
      default: () => { return [] }
    }
  },
  data () {
    return {
      documentName: "",
      error: { message: null },
      showDialog: false,
      methodName: "移動",
      cancelText: "キャンセル",
      duplicatedItems: [],
    };
  },
  watch: {
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "documentNewPath",
      "documentRootPath"
    ]),
    validatePath () {
      let validate = true;
      const newFullPath = `${this.documentRootPath}${this.documentNewPath}`
      this.moveTargetDocments.forEach(item => {
        const srcPath = item.size ? item.path : `${item.path}/`
        const dstPath = item.size ? `${newFullPath}${item.name}` : `${newFullPath}${item.name}/`

        const isChildFolderPath = !item.size && newFullPath.startsWith(srcPath);
        const isSamePath = srcPath === dstPath;

        if (isChildFolderPath || isSamePath) {
          validate = false
          return
        }
      })

      const hasDuplicatedItems = this.duplicatedItems.length > 0;

      return validate || hasDuplicatedItems;
    },
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "moveFile",
      "moveFolder",
      "existsFile",
      "existsFolder"
    ]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_SELECTED_MOVE_SOURCE",
      "SET_DOCUMENT_NEW_PATH",
      "SET_SELECTED_MOVE_DIAROG_FOLDER"
    ]),
    show () {
      this.showDialog = true;
      this.SET_DOCUMENT_NEW_PATH("")
      this.SET_SELECTED_MOVE_DIAROG_FOLDER("tree-root")
      this.validateExists(this.documentNewPath);
    },

    async validateExists (val) {

      if (!this.validatePath) return;
      this.duplicatedItems = []
      const newFullPath = `${this.documentRootPath}${val}`
      const promiseAll = this.moveTargetDocments.map(item => {

        if (item.size) {
          //ファイルの存在チェック
          const dstPath = `${newFullPath}${item.name}`;
          return this.existsFile(dstPath)
            .then(e => {
              if (!e) return;
              const path = `/${val}${item.name}`
              this.duplicatedItems.push({ path: path, type: "ファイル" })
            });
        } else {
          //フォルダの存在チェック
          const payload = {
            name: item.name,
            path: `${newFullPath}`
          }
          return this.existsFolder(payload)
            .then(e => {
              if (!e) return;
              const path = `/${val}${item.name}/`
              this.duplicatedItems.push({ path: path, type: "フォルダ" })
            });
        }

      })

      await Promise.all(promiseAll)



    },
    async moveDocument () {
      try {
        const destinationPath = `${this.documentRootPath}${this.documentNewPath}`;

        const folders = this.moveTargetDocments.filter(item => !("size" in item))
          .map(item => {
            return {
              "path": `${item.path}/`
            }
          });

        const files = this.moveTargetDocments.filter(item => "size" in item)
          .map(item => {
            return {
              "path": item.path
            }
          });

        this.$vs.loading();

        if (folders.length > 0) {
          const payload = {
            destination_folder: destinationPath,
            documents: folders
          };
          await this.moveFolder(payload)
        }

        if (files.length > 0) {
          const payload = {
            destination_folder: destinationPath,
            documents: files
          };
          await this.moveFile(payload)
        }

        this.$vs.notify({
          title:
            `船舶書類の移動が完了しました`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$vs.loading.close();
        this.close();
      } catch (e) {
        console.error(e)
        this.$vs.notify({
          title: `船舶書類の移動に失敗しました`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.$vs.loading.close();
        this.close();
      }
    },

    close () {
      this.cleanUp();
    },

    cancel () {
      this.cleanUp();
    },

    cleanUp () {
      this.showDialog = false;
      this.duplicatedItems = [];
      this.$nextTick(() => {
        this.$emit("moveDocuments", []);
        this.SET_DOCUMENT_NEW_PATH("")
        this.SET_SELECTED_MOVE_DIAROG_FOLDER("")
      });

    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#document-move-dialog {
  .vs-dialog {
    max-width: 600px;
  }
  
  .scroll-area {
    max-height: 120px;
  }

  z-index: 288;

  
}
</style>
